export default __webpack_public_path__ + "static/media/Jason Crow.59144811.jpg";